import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star, MapPin } from 'lucide-react';

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Rohit Sharma",
      location: "Delhi, India",
      rating: 5,
      title: "Reliable Cab Booking Experience",
      content: "Booked a Sedan for Delhi local sightseeing. The cab was neat and comfortable, and the driver was very polite. My Journey Cabs is truly reliable for city rides!",
      image: "https://img.freepik.com/premium-photo/portrait-young-handsome-bearded-indian-man-park-outdoors_251136-72386.jpg"
    },
    {
      id: 2,
      name: "Priya Nair",
      location: "Bangalore, Karnataka",
      rating: 5,
      title: "Excellent Service!",
      content: "I used the SUV service from Bangalore Airport to Mysore. Smooth ride and on-time pickup. Excellent service and coordination!",
      image: "https://media.istockphoto.com/id/1156869844/photo/businesswoman-stock-images.jpg?s=612x612&w=0&k=20&c=z-_pnHl0U-RsZTK6yLaQ2KbFkZIemRXpj6M6EM0LQXw="
    },
    {
      id: 3,
      name: "Ankit Verma",
      location: "Hyderabad, India",
      rating: 4,
      title: "Safe and Comfortable Rides",
      content: "We hired a Tempo Traveller for our family trip to Srisailam. The vehicle was spacious and clean, and the driver was very cooperative throughout the journey.",
      image: "https://img.freepik.com/free-photo/smiling-businessman-face-portrait-wearing-suit_53876-148138.jpg?t=st=1761839332~exp=1761842932~hmac=d7f9569c1ea7c9d6985f8916243b4d66b6f4fdb93e280d7a324949bc313d9f63"
    },
    {
      id: 4,
      name: "Neha Das",
      location: "Puri, India",
      rating: 5,
      title: "Perfect for Family Trips",
      content: "Our group used a Bus rental for Puri to Konark temple visit. It was a wonderful experience — well-maintained bus and friendly driver.",
      image: "https://media.istockphoto.com/id/1254176393/photo/portrait-of-a-happy-woman-of-indian-ethnicity.jpg?s=612x612&w=0&k=20&c=In7iJKJ0GXYatpVnLbSRqN-bbqwnXJqy4C0AjGgyUzE="
    },
    {
      id: 5,
      name: "Suresh Iyer",
      location: "Chennai, India",
      rating: 5,
      title: "Best Outstation Service",
      content: "Booked a Fortuner for an outstation business trip. Luxury, comfort, and punctuality — everything was perfect. Highly recommend My Journey Cabs!",
      image: "https://static.vecteezy.com/system/resources/thumbnails/050/519/732/small/smiling-confident-indian-business-man-employee-looking-at-camera-sitting-at-work-desk-with-laptop-computer-portrait-of-smart-happy-businessman-office-worker-or-entrepreneur-posing-at-modern-workplace-free-photo.jpeg"
    },
    {
      id: 6,
      name: "Aditi Gupta",
      location: "Jaipur, India",
      rating: 4,
      title: "Great for Airport Transfers",
      content: "We rented an SUV for Jaipur to Udaipur trip. The journey was safe, comfortable, and driver knew all the best food stops on the way!",
      image: "https://t4.ftcdn.net/jpg/04/98/81/37/360_F_498813770_KCXWSWs0zYkC3O8gGr7axxVcYeuEB766.jpg"
    },
    {
      id: 7,
      name: "Vikram Patel",
      location: "Mumbai, India",
      rating: 5,
      title: "Trustworthy and Affordable",
      content: "Used the airport transfer service with a Sedan. Quick response and smooth ride. Great experience overall!",
      image: "https://media.istockphoto.com/id/1212177440/photo/portrait-of-a-happy-man-of-indian-origin.jpg?s=612x612&w=0&k=20&c=T-hCGhKTZWd3lUk6XugDdCs-n-yV_blogAKgdhAqmBI="
    },
    {
      id: 8,
      name: "Divya Reddy",
      location: "Hyderabad, India",
      rating: 5,
      title: "Seamless Corporate Travel",
      content: "I regularly use My Journey Cabs for airport transfers. The drivers are always on time and the cars are spotless. Excellent service!",
      image: "https://t4.ftcdn.net/jpg/03/72/35/21/360_F_372352148_cDRhhvwHmMxyxwHvurii2KU6SbaYkGTD.jpg"
    },
    {
      id: 9,
      name: "Arjun Mehta",
      location: "Delhi NCR, India",
      rating: 4,
      title: "Clean and Well-Maintained Vehicles",
      content: "We took a Fortuner for a corporate trip. The ride was smooth, and the premium experience made our journey special. Thank you My Journey Cabs!",
      image: "https://t3.ftcdn.net/jpg/07/96/86/50/360_F_796865040_sm4wZxQzHYCbAAdxi4vO2dc1GMd9PhdX.jpg"
    },
    {
      id: 10,
      name: "Kavita Joshi",
      location: "Pune, India",
      rating: 5,
      title: "Solo Travel Made Easy",
      content: "Booked a Sedan for Pune Airport pickup. The car arrived before time and the driver was very professional. Really impressed with My Journey Cabs!",
      image: "https://img.freepik.com/free-photo/close-up-young-woman-looking-camera-sitting-against-red-metallic-backdrop_23-2148204763.jpg?semt=ais_hybrid&w=740&q=80"
    },
    {
      id: 11,
      name: "Ramesh Chauhan ",
      location: "Ahmedabad, India",
      rating: 5,
      title: "Punctual and Professional",
      content: "We hired an SUV for a weekend trip to Mount Abu. The cab was comfortable and clean, and the driver knew all the best routes. Excellent experience!",
      image: "https://www.shutterstock.com/shutterstock/videos/1093463231/thumb/7.jpg?ip=x480"
    },
    {
      id: 12,
      name: "Sneha Roy",
      location: "Bhubaneswar, India",
      rating: 4,
      title: "Great Weekend Gateway Partner",
      content: "Our family booked a Tempo Traveller for the Puri–Bhubaneswar tour. Smooth booking process and very friendly driver. Will definitely travel again!",
      image: "https://dm0qx8t0i9gc9.cloudfront.net/thumbnails/video/rS5r4eB/5261662-3-4snn84kp_thumbnail-1080_07.png"
    },
    {
      id: 13,
      name: "Harpreet Singh",
      location: "Amritsar, India",
      rating: 5,
      title: "Best Value for Money",
      content: "Used My Journey Cabs for airport transfer in a Fortuner. Premium service and very safe driving. Totally worth it!",
      image: "https://media.istockphoto.com/id/958064228/photo/portrait-of-happy-young-man.jpg?s=612x612&w=0&k=20&c=lZoxAGwQd_IL1p50R6FCXwbKtofoSuknmAKJod6OkzQ="
    },
    {
      id: 14,
      name: "Nithya R",
      location: "Chennai, Tamil Nadu",
      rating: 5,
      title: "Excellent Customer Support",
      content: "Had to make a last-minute change to my booking and their customer support team was incredibly helpful and responsive. Problem solved in minutes!",
      image: "https://www.shutterstock.com/shutterstock/videos/1064301436/thumb/1.jpg?ip=x480"
    },
    {
      id: 15,
      name: "Aarav Tiwari",
      location: "Goa, India",
      rating: 5,
      title: "My Go-To Travel Partner",
      content: "We rented a Mini Bus for our office group tour in Goa. The bus was new, comfortable, and driver was very patient. Great experience with My Journey Cabs",
      image: "https://t4.ftcdn.net/jpg/03/80/58/23/360_F_380582318_5lJ52eVLcePphpM4pMHdew3wgopfhQSc.jpg"
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  return (
    <section className="py-8 sm:py-12 lg:py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            What Our <span className="text-yellow-600">500+ Happy Customers</span> Say
          </h1>
        </div>

        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center">
          
          {/* Left Content - Testimonial */}
          <div className="relative order-2 lg:order-1 w-full">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentTestimonial}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                transition={{ duration: 0.4 }}
                className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-sm border border-gray-100"
              >
                {/* About Badge */}
                <div className="inline-block bg-yellow-50 text-yellow-700 px-3 sm:px-4 py-1 sm:py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6 border border-yellow-200">
                  About
                </div>

                {/* Testimonial Title */}
                <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                  {testimonials[currentTestimonial].title}
                </h2>

                {/* Testimonial Content */}
                <div className="max-h-[120px] sm:max-h-[150px] md:max-h-none overflow-y-auto">
                  <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6 md:mb-8 pr-2">
                    {testimonials[currentTestimonial].content}
                  </p>
                </div>

                {/* Star Rating */}
                <div className="flex items-center gap-1 mb-4 sm:mb-6">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 ${
                        i < testimonials[currentTestimonial].rating
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'fill-gray-300 text-gray-300'
                      }`}
                    />
                  ))}
                </div>

                {/* Customer Info */}
                <div className="border-t border-gray-200 pt-4 sm:pt-6">
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-1 sm:mb-2">
                    {testimonials[currentTestimonial].name}
                  </h3>
                  <div className="flex items-center gap-2 text-gray-600 text-xs sm:text-sm">
                    <MapPin className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span>{testimonials[currentTestimonial].location}</span>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Desktop Pagination Controls */}
            <div className="hidden lg:flex items-center justify-between mt-6 md:mt-8">
              <button
                onClick={prevTestimonial}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 bg-white border border-gray-300 hover:border-gray-400 rounded-lg px-4 py-2"
              >
                <ChevronLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                <span className="font-semibold text-sm sm:text-base">Prev</span>
              </button>

              {/* Pagination Dots */}
              <div className="flex items-center gap-1 sm:gap-2">
                {testimonials.slice(0, 8).map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToTestimonial(index)}
                    className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${
                      index === currentTestimonial
                        ? 'bg-yellow-500 scale-125'
                        : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                  />
                ))}
              </div>

              <button
                onClick={nextTestimonial}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 bg-white border border-gray-300 hover:border-gray-400 rounded-lg px-4 py-2"
              >
                <span className="font-semibold text-sm sm:text-base">Next</span>
                <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
              </button>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative order-1 lg:order-2 w-full">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentTestimonial}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 1.05 }}
                transition={{ duration: 0.4 }}
                className="relative rounded-xl sm:rounded-2xl overflow-hidden shadow-lg sm:shadow-xl aspect-square sm:aspect-[4/3]"
              >
                <img 
                  src={testimonials[currentTestimonial].image} 
                  alt={testimonials[currentTestimonial].name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-60"></div>
                
                {/* Floating Rating Badge */}
                <div className="absolute top-3 sm:top-4 right-3 sm:right-4 bg-white/90 backdrop-blur-sm rounded-full px-2 sm:px-3 py-1 sm:py-2 flex items-center gap-1 shadow-lg">
                  <Star className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400" />
                  <span className="text-xs sm:text-sm font-bold text-gray-900">
                    {testimonials[currentTestimonial].rating}.0
                  </span>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        {/* Mobile Pagination */}
        <div className="flex flex-col items-center mt-6 lg:hidden">
          {/* Pagination Dots */}
          <div className="flex items-center gap-2 mb-4">
            {testimonials.slice(0, 6).map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentTestimonial
                    ? 'bg-yellow-500 scale-125'
                    : 'bg-gray-300'
                }`}
              />
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex items-center gap-4 w-full max-w-xs">
            <button
              onClick={prevTestimonial}
              className="flex-1 flex items-center justify-center gap-2 p-3 rounded-xl border border-gray-300 hover:border-gray-400 transition-colors duration-200 bg-white shadow-sm"
            >
              <ChevronLeft className="w-4 h-4 text-gray-600" />
              <span className="font-semibold text-sm">Previous</span>
            </button>
            
            <button
              onClick={nextTestimonial}
              className="flex-1 flex items-center justify-center gap-2 p-3 rounded-xl border border-gray-300 hover:border-gray-400 transition-colors duration-200 bg-white shadow-sm"
            >
              <span className="font-semibold text-sm">Next</span>
              <ChevronRight className="w-4 h-4 text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;